export class StaffManagementActions {
  add_staff = {
    name: 'Scheduler Add New Staff',
    label: 'Add Staff Button Click'
  };
}

